export const removeFileExtensions = (name) => {
  const ext = name?.match(/\.([^.]+)$/)?.[0];
  const fileName = name?.replace(ext, '');

  return fileName;
};
